// Design tokens must load before any component stylesheet so the cascade is
// predictable. Keep this first. Spec: /DESIGN.md
import './styles/tokens.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import LandingPage from './components/LandingPage';
import CookieBanner from './components/CookieBanner';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import EulaPage from './pages/EulaPage';
import DisclaimerPage from './pages/DisclaimerPage';
import DataSciencePage from './pages/DataSciencePage';
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import AccountPage from './pages/AccountPage';
import RefundPage from './pages/RefundPage';
import ContactPage from './pages/ContactPage';
import SupportPage from './pages/SupportPage';
import Pick3Page from './pages/Pick3Page';
import NotFoundPage from './pages/NotFoundPage';
import { AuthProvider } from './AuthContext';
import reportWebVitals from './reportWebVitals';

/*
  How routing works in React:

  BrowserRouter watches the URL bar. When the URL changes, it renders
  the matching <Route>. No full page reload happens — React just swaps
  the component. This is called "client-side routing".

  Route layout:
    /          → LandingPage (marketing page)
    /app       → App (the data analysis dashboard)
    /terms     → Terms of Service
    /privacy   → Privacy Policy
    /eula      → EULA
*/

const container = document.getElementById('root');

// Prerendered routes arrive with real markup already in #root (see
// scripts/prerender.mjs). Hydrating attaches to that markup instead of
// throwing it away and re-rendering, which avoids a flash of the static
// content being replaced. A route with no snapshot still mounts normally.
const app = (
  <React.StrictMode>
    <AuthProvider>
    <BrowserRouter>
      {/* Global overlays — render on top of every page */}
<CookieBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<App />} />
        <Route path="/data-science" element={<DataSciencePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/eula" element={<EulaPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/refunds" element={<RefundPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/pick3" element={<Pick3Page />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();
